import { render, staticRenderFns } from "./Eventsview.vue?vue&type=template&id=2c4221a0&"
import script from "./Eventsview.vue?vue&type=script&lang=js&"
export * from "./Eventsview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports